const Pattern = {
    password: /^(?=.*[a-zäöü])(?=.*[A-ZÄÖÜ])(?=.*\d)(?=.*[@$!%*?&_+-\s])[A-ZÄÖÜa-zäöü\d@$!%*?&_+-\s]{8,}$/,
    email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};

export default Pattern;
